import { UseDelegateWalletMessageParams } from 'src/components/DelegateWalletMessage/types';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import { abbreviateAddress } from '@velocity-exchange/common';

export default function useDelegateWalletMessage({
	inherited,
}: UseDelegateWalletMessageParams) {
	const rootAuthority = useVelocityAccountStore((s) =>
		s.getCurrentUserAccount()?.authority?.toString()
	);
	const isDelegate = useVelocityAccountStore(
		(s) => s.getCurrentUserAccount()?.isDelegatedTo
	);

	if (!rootAuthority || !isDelegate) {
		return;
	}

	return `This delegated wallet inherits ${inherited} from the main wallet: ${abbreviateAddress(
		rootAuthority
	)}`;
}
